import React from 'react';
import routes from 'src/routes';
import { useLocation } from 'react-router-dom';
import { Application } from 'src/constants/application.const';
import { useAppPermission } from 'src/hooks/useAppPermission';
import { QaErrorsProvider } from './QaErrorsProvider';
import { QaErrors } from './QaErrors';

export default () => {
  const location = useLocation();
  const [{ isAllowed }, redirect] = useAppPermission(Application.Nucleus.id, ['error_monitoring']);
  if (!isAllowed && location.pathname === '/nucleus/qa/errorMonitoring') {
    return redirect(routes.optCenter);
  }

  return (
    <QaErrorsProvider>
      <QaErrors />
    </QaErrorsProvider>
  );
};
